// extracted by mini-css-extract-plugin
export default {"DrawerMenu":"DrawerMenu_DrawerMenu__41opJ","bottom":"DrawerMenu_bottom__k7T8Y"};